import { Component, OnInit } from '@angular/core';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ModalUnitComponent } from '@shared/components/modal-list/modal-unit/modal-unit.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'modal-list',
  templateUrl: './modal-list.component.html',
  styleUrl: './modal-list.component.scss',
  imports: [CommonModule, ModalUnitComponent],
})
export class ModalListComponent implements OnInit {
  modal$ = this.modalService.getActiveModal();

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.handleKeyboardEvent();
  }

  close(el: MouseEvent): void {
    const elTarget = el.target as HTMLElement;

    const isContainer = el && elTarget && elTarget.classList && elTarget.classList.contains('js-container-modal-list');
    const modals = this.modalService.getAllAsValue();
    const modal = modals[modals.length - 1];

    if (isContainer) {
      if (modal.onSkip) {
        modal.onSkip();
      } else if (!modal.disableClose) {
        this.modalService.close();
      }
    }
  }

  handleKeyboardEvent() {
    const _this = this;
    const modals = _this.modalService.getAllAsValue();
    const modal = modals[modals.length - 1];
    if (modal) {
      window.document.body.addEventListener('keyup', function (event) {
        if ((event.key === 'Escape' || event.key === 'Esc') && !modal.disableClose) {
          _this.modalService.skip();
        }
      });
    }
  }
}
